import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";

import "./TopNavigationBar.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";
import LanguageSwitcher from "./LanguageSwitcher";

export default function TopNavigationBar() {
	const { i18n } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	const IconImg = IMAGES["Icon.png"];

	const isRoot = location.pathname === "/";
	const [expanded, setExpanded] = useState(false);

	const goBack = () => navigate(-1);

	const links = [
		{ path: "/", label: "home" },
		{ path: "/latest-news", label: "latestNews" },
		{ path: "/wsom-app", label: "ourApp" },
		{ path: "/become-host", label: "becomeAHost" },
		{ path: "/shop", label: "onlineShop" },
		{ path: "/photo", label: "photo" },
		{ path: "/about-us", label: "aboutUs" },
	];

	const handleNavigate = (path) => {
		navigate(path);
		setExpanded(false); // collapse menu after navigating
	};

	return (
		<Navbar
			bg="navbar-color"
			variant="dark"
			sticky="top"
			expand="lg"
			expanded={expanded}
			onToggle={(isOpen) => setExpanded(isOpen)}
			className="bg-body-tertiary"
		>
			<Container>
				<Navbar.Brand style={{ display: "flex", alignItems: "center" }}>
					{!isRoot && (
						<span
							onClick={goBack}
							style={{
								marginRight: "1rem",
								display: "flex",
								alignItems: "center",
								cursor: "pointer",
							}}
						>
							<ArrowBackIcon fontSize="small" />
						</span>
					)}
					<span
						onClick={() => handleNavigate("/")}
						style={{ cursor: "pointer" }}
					>
						<img
							src={IconImg}
							alt="World Series Of Mahjong"
							style={{
								height: "30px",
								marginRight: "10px",
								verticalAlign: "middle",
							}}
						/>
						{getTranslation(i18n, "topNavigationBar.brandTitle")}
					</span>
				</Navbar.Brand>

				{/* Mobile menu toggle */}
				<Navbar.Toggle aria-controls="main-navbar-nav" />

				{/* Collapsible nav links */}
				<Navbar.Collapse
					id="main-navbar-nav"
					className="justify-content-end"
				>
					<Nav className="align-items-center">
						{links.map((link, idx) => (
							<Nav.Link
								key={idx}
								onClick={() => handleNavigate(link.path)}
							>
								{getTranslation(
									i18n,
									`topNavigationBar.buttons.${link.label}`
								)}
							</Nav.Link>
						))}
						<LanguageSwitcher
							onLanguageChange={() => setExpanded(false)}
						/>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
